export const ALTERNATE_SERVICES = [
  // "visit_primary_care_physician",
  "Visit Primary Care Physician",
  "Go to Urgent Care",
  "Go to Emergency Room",
  "Nothing",
];
